import React from 'react';
import Portal from '../Portal';
import {
  HeaderContainer,
  CloseIcon
} from './Modal.styles';
import { ModalProps, defaultProps } from './Modal.props';

function Modal({
  children,
  open,
  headerText,
  toggleModal,
  disableBackdropClick,
  whiteBg,
  showHeader,
  className,
  modalTestName,
  fullscreenOnMobile,
  Header,
  Content,
  Backdrop,
  CloseButton
}: ModalProps) {
  return (
    <Portal open={open} rootClassname="modal-root">
      <Backdrop
        data-cv-test="Modal.Backdrop"
        onClick={e => (disableBackdropClick ? null : toggleModal(e))}
      />
      <Content
        whiteBg={whiteBg}
        className={className}
        data-cv-test={modalTestName}
        fullscreenOnMobile={fullscreenOnMobile}
      >
        {showHeader ? (
          <HeaderContainer>
            <Header>{headerText}</Header>
            <CloseButton
              onClick={toggleModal}
              aria-label="Close Modal"
            >
              <CloseIcon />
            </CloseButton>
          </HeaderContainer>
        ) : null}
        {children}
      </Content>
    </Portal>
  );
}

Modal.defaultProps = defaultProps;

export default Modal;
